<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 138.836 56.517">
    <g id="Truck" transform="translate(10739.462 392.182)">
      <path id="Path_87092" data-name="Path 87092"
        d="M19.409,206.955a11.2,11.2,0,1,0,11.2,11.2,11.209,11.209,0,0,0-11.2-11.2m0,20.094a8.9,8.9,0,1,1,8.9-8.9,8.908,8.908,0,0,1-8.9,8.9"
        transform="translate(-10724.274 -565.016)" :fill="themeColor" />
      <path id="Path_87093" data-name="Path 87093"
        d="M49.323,206.955a11.2,11.2,0,1,0,11.2,11.2,11.209,11.209,0,0,0-11.2-11.2m0,20.094a8.9,8.9,0,1,1,8.9-8.9,8.906,8.906,0,0,1-8.9,8.9"
        transform="translate(-10668.746 -565.016)" :fill="themeColor" />
      <path id="Path_87094" data-name="Path 87094"
        d="M137.707,237.019h.26a1.143,1.143,0,0,0,.888-1.117v-4.567a1.139,1.139,0,0,0-.594-1.008h0l-3.13-1.714.477-1.177a12.166,12.166,0,0,0-.674-10.56,3.877,3.877,0,0,0-3.1-1.765l-29.5-2.456-13.362-17.2c-.223-.28-.594-.317-.9-.443H63.527a1.143,1.143,0,0,0-1.143,1.14v18.2H3.722a1.146,1.146,0,0,0-1.143,1.054l.006,11.848L.354,229.482a1.156,1.156,0,0,0-.334.811v10.051a1.144,1.144,0,0,0,.991,1.134H16.358a1.146,1.146,0,0,0,1.148-1.14,1.146,1.146,0,0,0-.331-.808,1.128,1.128,0,0,0-.805-.337H2.305v-8.432l2.228-2.231a1.141,1.141,0,0,0,.337-.811V216.637l83.621.026h0a1.144,1.144,0,1,0,.009-2.288H64.672V197.294H87.488l13.327,17.155a1.157,1.157,0,0,0,.811.443l30.865,2.574.514.685a9.843,9.843,0,0,1,.483,8.3l-.3.774-.828.114a1.14,1.14,0,0,0-.377,2.137L136.565,232v3.882a1.144,1.144,0,0,0,1.143,1.142"
        transform="translate(-10739.481 -587.191)" :fill="themeColor" />
      <path id="Path_87095" data-name="Path 87095"
        d="M19.343,210.477a1.142,1.142,0,0,0,.006,2.285h48.5a1.142,1.142,0,0,0,0-2.285Z"
        transform="translate(-10705.712 -558.478)" :fill="themeColor" />
    </g>
  </svg>

</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
